<template>
  <section>
    <h2 class="h2Title">앱 버전 관리</h2>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">

              <dl>
                <dd>
                  <v-col sm="12">
                    <v-text-field label="검색"
                                  v-model="searchQuery" v-on:keyup.enter="search"
                                  dense clearable flat outlined/>
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList">
              <v-btn color="primary" class="vBtn vIconResize mgr" @click="createForm" dark>
                <v-icon left>mdi mdi-playlist-plus</v-icon>
                버전 추가
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            :headers="headers"
            :items="datasets"
            item-key="versionId"
            class="elevation-1"
            :search="searchQuery"
        >
          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY.MM.DD HH:mm') }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                @click="updateVersion(item.versionId)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
                small
                @click="deleteVersion(item.versionId)"
            >
              mdi-delete
            </v-icon>
          </template>

        </v-data-table>
      </div>
    </article>

    <v-dialog v-model="formDialog" max-width="500px" @click:outside="formDialog = false" @keydown.esc="formDialog = false">
      <v-card>
        <v-card-title class="headline">버전 추가</v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="formVersion">

              <v-col>
                <v-text-field label="버전정보" dense solo flat outlined clearable v-model="version.version"
                              :rules="[rules.required]"/>
              </v-col>

              <v-col>
                <v-switch
                    v-model="version.appType"
                    flat
                    class="custom-red"
                    false-value="ANDROID"
                    true-value="IOS"
                    :label="!version.appType || version.appType === 'ANDROID' ? 'ANDROID' : 'IOS'"
                ></v-switch>
              </v-col>

            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" dark @click="formDialog = false">창닫기</v-btn>
          <v-btn color="primary" dark @click="save">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </section>
</template>

<script>
import versionApi from '@/api/VersionApi'

export default {
  name: "Version",
  components: {
  },
  data: () => ({
    version: {},
    versionId: null,
    formDialog: false,
    headers: [
      {text: '버전 아이디', value: 'versionId', align: 'left'},
      {text: '버전 정보', value: 'version', align: 'center'},
      {text: 'APP 종류', value: 'appType', align: 'center'},
      {text: '생성일', value: 'createdAt', align: 'center'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    rules: {
      required: value => !!value || '필수 입력 항목입니다..'
    },
    searchQuery: null,
    datasets: [],
    dialogVisible: false,
  }),
  watch: {
  },
  methods: {
    search() {
      versionApi.list().then(data => {
        this.datasets = data;
      });
    },
    createForm() {
      this.formDialog = true;
      this.$refs.formVersion?.resetValidation();
      this.version = {};
      // this.$router.push({path: `/version/form`})
    },
    async save() {
      if(!await this.$refs.formVersion.validate())
        return;

      versionApi.save(this.version).then(() => {
        this.formDialog = false
        alert("저장 되었습니다.");
        this.search();
      });
    },
    updateVersion(versionId) {
      versionApi.get(versionId).then(data => {
        this.version = data
        this.formDialog = true
      })
    },
    deleteVersion(versionId) {
      if(confirm('버전 정보를 삭제하시겠습니까?')) {
        versionApi.delete(versionId).then(() => {
          this.search();
        });
      }
    }
  },
  created: function () {
    this.search();
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
